import { render } from "./sider.vue?vue&type=template&id=3b22159d&scoped=true"
import script from "./sider.vue?vue&type=script&lang=js"
export * from "./sider.vue?vue&type=script&lang=js"

import "./sider.vue?vue&type=style&index=0&id=3b22159d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b22159d"]])

export default __exports__